import { render, staticRenderFns } from "./MenuTabs.vue?vue&type=template&id=1c9acb5e&scoped=true&"
import script from "./MenuTabs.vue?vue&type=script&lang=js&"
export * from "./MenuTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9acb5e",
  null
  
)

export default component.exports